interface IDetailInfoArea {
    title: string,
    value: string | number
    isTag?: boolean
}

const DetailInfoArea = ({ title, value, isTag }: IDetailInfoArea) => {

    return (
        <div className={`flex items-center`}>
            <div className="w-[150px] text-lg shrink-0">
                {
                    isTag ?
                        <p className='flex items-center gap-2' dangerouslySetInnerHTML={{ __html: title }}></p> :
                        <p>{title}</p>
                }
            </div>
            <div className={`flex items-center min-w-[600px] bg-[#F8F8FA] rounded h-10 px-4`}>
                {value}
            </div>
        </div>
    )
}

export default DetailInfoArea;